import { FormControl } from '@angular/forms';

import { isValidCNPJ } from '@brazilian-utils/brazilian-utils';

export class CNPJValidator {
  static isValid(control: FormControl) {
    if (isValidCNPJ(control.value)) {
      return null;
    }

    return { invalidCNPJ: true };
  }
}
